<template>
    <div
        class="search-input-field"
    >
        <input type="text"
            v-model="store.order.addresses[index].address"
            v-bind:class="{loading: loading}"
            @focusin="isOpen ? store.stateFull(true) : focus()"
            @focusout="focus(false)"
            @input="search()"
            v-bind:placeholder="index == 0 ? 'Адрес отправки' : 'Адрес доставки'"
        >
        <div class="result-items" v-if="focused">
            <div class="not-found-item" v-if="showNotFound">
                Ничего не найдено
            </div>
            <div class="comment-item" v-if="showComment">
                Введите минимум 2 символа для поиска
            </div>
            <div
                class="result-item"
                v-for="(value, key) in items"
                :key="key"
                @click="select(value)"
                @mousedown="select(value)"
            >
                <span class="name">{{value.address}}</span>
                <span class="city">{{value.city}}</span>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    props: ["store", "index", "Api", "isOpen"],
    methods: {
        focus: function(state = true){
            this.focused = state;
            if (!state) {
                if (this.timeoutId !== null) {
                    clearTimeout(this.timeoutId);
                }
            }else{

                if (!this.items.length){
                    this.search();
                }
            }
        },
        search: function () {
            this.showNotFound = false;
            this.items = [];
            const currentAddress = this.store.order.addresses[this.index];
            const input = currentAddress.address !== null ? currentAddress.address.trim() : '';
            currentAddress.house = null;
            currentAddress.lat = null;
            currentAddress.lng = null;
            currentAddress.cost = 0;
            if (input.length < 2){
                this.showComment = true;
            }else{
                this.showComment = false;
                if (this.timeoutId !== null){
                    clearTimeout(this.timeoutId);
                }
                this.loading = true;
                this.timeoutId = setTimeout(() => {
                    this.Api.getAddressByName(input).then((json) => {
                        this.showNotFound = true;
                        this.loading = false;
                        if (typeof json.data.items != "undefined"){
                            if (json.data.items.length){
                                this.showNotFound = false;
                                this.items = json.data.items;
                            }
                        }
                    }).catch(() => {
                        this.showNotFound = true;
                        this.loading = false;
                    })
                }, 500);
            }
        },
        select: function(address){
            const currentAddress = this.store.order.addresses[this.index];
            currentAddress.address = address.address;
            currentAddress.lat = address.lat;
            currentAddress.lng = address.lng;
            currentAddress.house = address.house;
            currentAddress.cost = address.cost;
            this.focus(false);
        }
    },
    data(){
        return {
            loading: false,
            showNotFound: false,
            showComment: true,
            focused: false,
            items: [],
            timeoutId: null
        }
    }
}
</script>
<style lang="scss">
    #yacurier-form{
        .search-input-field {
            position: relative;
            input[type="text"] {
                background-image: url('../../assets/pointer-icon.svg');
                background-position: 15px center;
                background-repeat: no-repeat;
                background-size: 8px;
                border: 1px solid #C3C8D7;
                box-sizing: border-box;
                padding: 10px;
                padding-left: 35px !important;
                transition: border-color .15s ease-in;
                width: 100%;
                &:focus{
                    border-color: #3775F6;
                }
                &.loading{
                    background-image: url('../../assets/loader.svg');
                }
            }
            .result-items{
                background: #FFF;
                border: 1px solid #C3C8D7;
                border-top: none;
                left: 0;
                position: absolute;
                right: 0;
                z-index: 1;
                .result-item{
                    border-top: 1px solid #C3C8D7;
                    padding: 10px;
                    &:first-child{
                        border-top: none;
                    }
                    &:hover{
                        background: #EEE;
                    }
                    span{
                        display: block;
                        overflow: hidden;
                        white-space: nowrap;
                        width: 100%;
                    }
                    .name{
                        font-size: 12px;
                    }
                    .city{
                        font-size: 10px;
                    }
                }
                .not-found-item,
                .comment-item{
                    padding: 10px;
                    font-size: 12px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/elements/SearchAddress.vue